export default "__VITE_ASSET__J4JBSphs__"